import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import BASEURL from "../../BaseUrl";

export const uploadEmployeeDocumentAPI = createAsyncThunk(
  "employee/uploadDocument",
  async (file, thunkAPI) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const res = await axios.post(
        `${BASEURL}/api/employees/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "File upload failed",
      );
    }
  },
);

export const getEmployeeManagerOptionsAPI = createAsyncThunk(
  "employee/getEmployeeManagerOptionsAPI",
  async (_, thunkAPI) => {
    try {
      const res = await axios.get(`${BASEURL}/api/employees/options`);

      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message ||
          "Failed to fetch reporting manager options",
      );
    }
  },
);

export const createEmployeeAPI = createAsyncThunk(
  "employee/create",
  async (payload, thunkAPI) => {
    try {
      const res = await axios.post(`${BASEURL}/api/employees/create`, payload);

      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Employee creation failed",
      );
    }
  },
);
